// extracted by mini-css-extract-plugin
export var button = "_jb-2";
export var card = "_jb-0";
export var closeButtonContainer = "_jb-3";
export var iconContainer = "_jb-1";